<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-accordion styleClass='bp-selectable-contact-list' data-testid="bp-selectable-contact-list">
  <p-accordionTab [(selected)]='isContactListExpanded' data-testid="contact-list-accordion">
    <ng-template pTemplate='header'>
      {{ 'bp-selectable-contact-list.contact-list-title' | translate }}
      <span [ngClass]="{
      'color-danger': this.bpSelectedContacts.length === 0,
      'color-info': this.bpSelectedContacts.length > 0}" class='bold ml-xs'>
      ({{ this.bpSelectedContacts.length }}/{{ contactList.length }}
        {{ 'bp-selectable-contact-list.selected' | translate }})
      </span>
    </ng-template>
    <ng-template pTemplate='content'>
      <div class='contact-list' *ngIf='bpSelectableContact && bpSelectableContact.length > 0' data-testid="contact-list">
        <ng-container *ngFor='let bpContact of bpSelectableContact; trackBy: trackBy; let $index = index'>
          <well-bp-selectable-contact-card [bpContact]='bpContact'
                                           [isPublic]='publicContacts()[$index]'
                                           [displayCheckbox]='displayCheckbox()'
                                           [showCompanyForContact]='showCompanyForContact'
                                           (bpChange)='onContactSelectionChange($event, bpContact)'
                                           [readOnly]='viewOnly || bpContact.disabled'
                                           [attr.data-testid]="'contact-card-' + $index" data-testid="bp-selectable-contact-card-select">
          </well-bp-selectable-contact-card>
        </ng-container>
      </div>
    </ng-template>
  </p-accordionTab>
</p-accordion>


